import { render } from "./PengumumanPemenangDetailExecutive.vue?vue&type=template&id=64c3c315&scoped=true"
import script from "./PengumumanPemenangDetailExecutive.vue?vue&type=script&lang=js"
export * from "./PengumumanPemenangDetailExecutive.vue?vue&type=script&lang=js"

import "./PengumumanPemenangDetailExecutive.vue?vue&type=style&index=0&id=64c3c315&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3c315"]])

export default __exports__